import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { container } from "@/lib/ui";

export function PageHeader({ eyebrow, title, subtitle, crumbs = [], children }) {
  return (
    <section className="relative bg-navy overflow-hidden" data-testid="page-header">
      <div className="absolute -right-20 -top-20 w-80 h-80 rounded-full bg-brandgreen/10 blur-3xl" />
      <div className={`${container} relative pt-12 pb-16 lg:pt-16 lg:pb-20`}>
        {crumbs.length > 0 && (
          <nav className="flex items-center flex-wrap gap-1.5 text-sm text-white/60 mb-6" aria-label="Breadcrumb">
            <Link to="/" className="hover:text-white transition-colors">Home</Link>
            {crumbs.map((c, i) => (
              <span key={i} className="flex items-center gap-1.5">
                <ChevronRight className="w-4 h-4" />
                {c.path ? (
                  <Link to={c.path} className="hover:text-white transition-colors">{c.name}</Link>
                ) : (
                  <span className="text-white/90">{c.name}</span>
                )}
              </span>
            ))}
          </nav>
        )}
        {eyebrow && (
          <span className="text-xs tracking-[0.22em] uppercase font-semibold text-brandgreen-light">{eyebrow}</span>
        )}
        <h1 className="mt-3 font-heading text-4xl sm:text-5xl font-bold tracking-tight text-white max-w-3xl leading-[1.08]">
          {title}
        </h1>
        {subtitle && <p className="mt-5 text-base lg:text-lg text-white/75 max-w-2xl leading-relaxed">{subtitle}</p>}
        {children && <div className="mt-8">{children}</div>}
      </div>
    </section>
  );
}
